(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-bg-motion]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const video = section.querySelector('video');
      const button = section.querySelector('.bg-motion-toggle');
      if (!video || !button) return;
      function sync() {
        const playing = !video.paused && !video.ended;
        button.classList.toggle('is-playing', playing);
        button.setAttribute('aria-label', playing ? button.dataset.pause : button.dataset.play);
        button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      }
      button.addEventListener('click', async () => {
        if (video.paused) {
          try { await video.play(); } catch (_) { video.controls = true; }
        } else video.pause();
        sync();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting && !video.paused) video.pause();
      }), { threshold: 0.05 }).observe(section);
      motion.addEventListener('change', e => { if (e.matches) video.pause(); });
      sync();
    });
    root.querySelectorAll('.bg-mobile-nav').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('nav a').forEach(a => a.addEventListener('click', () => menu.removeAttribute('open')));
      menu.addEventListener('keydown', e => {
        if (e.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
